var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-selector"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("选择门店")]), _vm._v(" "), _c('div', {
    staticClass: "search-bar"
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入门店名称或地址"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": !_vm.ready || _vm.searching,
      "loading": _vm.searching
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "map-message",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.error) + " "), (!_vm.ready) ? _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.initMap
    }
  }, [_vm._v("重新加载")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "map-message"
  }, [_vm._v("地图加载中…")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "map",
    staticClass: "map-canvas"
  }), _vm._v(" "), (_vm.results.length) ? _c('div', {
    staticClass: "search-results"
  }, _vm._l((_vm.results), function(item, index) {
    return _c('button', {
      key: index,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectResult(item)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(item.title))]), _c('span', [_vm._v(_vm._s(item.address))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v("搜索后选择具体门店，也可点击地图或拖动标记调整位置。")]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.ready || _vm.searching || !_vm.location
    },
    on: {
      "click": _vm.locationConfirm
    }
  }, [_vm._v("确定")])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bcff1382", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcff1382","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LocationSelector.vue
// module id = gdwd
// module chunks = 142